<div
  class="app-content-render"
  [style.scale]="((config$ | async).scale || 100) * 0.01"
  id="wrapperSVG"
  [ngClass]="{ loading: loading }"
  #content
>
  <h4 *ngIf="!loading && !svgRendered && isLoaded" innerHtml="{{ 'plugins.parts.no-svg' | translate }}"></h4>
  <h4 *ngIf="!isLoaded && !loading" innerHtml="{{ 'plugins.parts.select-page' | translate }}"></h4>
  <div id="svgWrapper" [style.visibility]="svgRendered ? 'visible' : 'hidden'"></div>
</div>
<button class="toggle-parts-button" (click)="toggleIsPartsVisible()">
  <app-icon size="lg" name="format-list-bulleted-add"></app-icon>
</button>
